import { render, staticRenderFns } from "./CostBearerProofOfTrainingPreview.vue?vue&type=template&id=3bc0c616&scoped=true"
import script from "./CostBearerProofOfTrainingPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerProofOfTrainingPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0c616",
  null
  
)

export default component.exports